import { createFileRoute } from '@tanstack/react-router'
import * as Sentry from '@sentry/react'

export const Route = createFileRoute('/_authenticated/sentry-test')({
  component: SentryTestPage,
})

function SentryTestPage() {
  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <div className="w-full max-w-md space-y-6 rounded-lg border p-8">
        <div className="text-center">
          <h1 className="text-2xl font-bold">Sentry Test</h1>
          <p className="mt-2 text-sm text-muted-foreground">
            Test error tracking and user association
          </p>
        </div>

        <div className="space-y-4">
          <ErrorButton />
          <CaptureExceptionButton />
          <LogTestButton />
        </div>
      </div>
    </div>
  )
}

function ErrorButton() {
  return (
    <button
      onClick={() => {
        throw new Error('This is your first error!')
      }}
      className="w-full rounded-md bg-red-600 px-4 py-2 text-white hover:bg-red-700"
    >
      Break the world
    </button>
  )
}

function CaptureExceptionButton() {
  return (
    <button
      onClick={() => {
        try {
          throw new Error('Manually captured exception')
        } catch (error) {
          Sentry.captureException(error, {
            extra: {
              test: true,
              timestamp: new Date().toISOString(),
            },
          })
          alert('Exception captured and sent to Sentry')
        }
      }}
      className="w-full rounded-md bg-orange-600 px-4 py-2 text-white hover:bg-orange-700"
    >
      Capture Exception
    </button>
  )
}

function LogTestButton() {
  return (
    <button
      onClick={() => {
        const { logger } = Sentry
        logger.info('Test info log', { test: true })
        logger.warn('Test warning log', { test: true })
        logger.error('Test error log', { test: true })
        alert('Logs sent to Sentry')
      }}
      className="w-full rounded-md bg-blue-600 px-4 py-2 text-white hover:bg-blue-700"
    >
      Test Logs
    </button>
  )
}
